// extracted by mini-css-extract-plugin
export default {"container":"viewExternalService_container__+sV++","content":"viewExternalService_content__nUmMs"};